import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getWant, saveWant, getSwimlanes} from "../services/api";

export function EditWant() {
    const { wantId } = useParams()
    const [want, setWant] = useState({})
    const [swimlanes, setSwimlanes] = useState([])
    const navigate = useNavigate()
    
    useEffect(() => {
        if (wantId !== "new") {
            getWant(wantId)
            .then(apiWant => {
                setWant(apiWant)
            })
            .catch(ex => {
                console.log("Error getting want: ", ex)
            })
        }
        
        getSwimlanes()
            .then(swimlanes => {
                setSwimlanes(swimlanes)
            })
            .catch(ex => {
                console.log("Error getting swimlanes: ", ex)
            })
    }, [])
    
    const setName = (event) => {
        setWant({
            ...want,
            name: event.target.value
        })
    }
    
    const setStartDate = (event) => {
        setWant({
            ...want,
            startDate: event.target.value
        })
    }
    
    const setCost = (event) => {
        setWant({
            ...want,
            cost: event.target.value
        })
    }
    
    const setPriority = (event) => {
        setWant({
            ...want,
            priority: event.target.value
        })
    }
    
    const updateSwimlane = (event) => {
        setWant({
            ...want,
            swimlaneId: parseInt(event.target.value)
        })
    }
    
    
    const submit = async (event) => {
        event.preventDefault()
        
        try {
            await saveWant(want)
            navigate("/wants")
        } catch (ex) {
            console.log("Error saving want: ", ex)
        }
    }
    
    return (
        <>
            <form onSubmit={submit}>
                <div className="form-group mb-3">
                    <label>Name</label>
                    <input type="text" className="form-control" value={want.name} onChange={setName}/>
                </div>
                <div className="form-group mb-3">
                    <label>Start Date</label>
                    <input type="text" className="form-control" value={want.startDate} onChange={setStartDate}/>
                </div>
                <div className="form-group mb-3">
                    <label>Cost</label>
                    <input type="text" className="form-control" value={want.cost} onChange={setCost}/>
                </div>
                <div className="form-group mb-3">
                    <label>Priority</label>
                    <input type="text" className="form-control" value={want.priority} onChange={setPriority} />
                </div>
                <div className="form-group mb-3">
                    <label>Swimlane</label>
                    <select className="form-control"
                            onChange={updateSwimlane}
                            value={want.swimlaneId}
                    >
                        <option value="null">Unassigned</option>
                        {swimlanes.map(o => {
                            return (
                                <option key={o.wantsSwimlaneId} value={o.wantsSwimlaneId}>{o.name}</option>
                            )
                        })}

                    </select>
                </div>
                <div className="form-group">
                    <button className="btn btn-primary">Submit</button>
                </div>
            </form>
        </>
    )

}